<style lang="scss" scoped="scoped">
p {
  color: #303133;
}
</style>

<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;padding: 20px;display: flex;flex-direction: column;justify-content: space-between;">
    <div ref="titleBar" class="titleBar" style="flex-shrink: 0;display: flex;align-items: center;">
      <p style="font-size: 16px;font-weight: 700;">
        {{ $t("shebeizhibiao") }}
      </p>
      <p style="font-size: 12px;line-height: 22px;color: #C0C4CC;margin-left: 12px;" v-if="target.timeRange">{{ $t("tongjishijian") }}&nbsp{{ target.timeRange.begin }}&nbsp~&nbsp{{ target.timeRange.end }}</p>
    </div>
    <div style="display: flex;justify-content: space-between;margin-top: 20px;flex-shrink: 0;padding: 0 30px;">
      <div v-for="(i, index) in [0, 1, 2]" style="height: 142px;">
        <p>{{ [$t("jin7richanliangzuigaoshebei"), $t("jin7rikaijilvzuigaoshebei"), $t("jin7rijiadonglvzuigaoshebei")][i] }}</p>
        <div v-for="(sort, j) in target.sortDatas[i]" style="display: flex;margin-top: 18px;align-items: center;">
          <div style="display: flex;flex-direction: column;justify-content: space-between;">
            <div :style="{ 'background-color': ['#F56C6C', '#E6A23C', '#C0C4CC'][j] }" style="display: flex;width: 18px;height: 18px;border-radius: 9px;justify-content: center;align-items: center;color: white;">
              {{ j + 1 }}
            </div>
          </div>
          <div style="color: #303133;font-size: 18px;flex: 1;margin-left: 16px;">
            {{ sort.equipmentName }}
          </div>
          <div style="color: #909399;font-size: 18px;line-height: 20px;margin-left: 16px;min-width: 60px;text-align: right;">
            <span v-if="i == 0">{{ sort.product }}</span>
            <span v-if="i == 1">{{ (sort.upRate * 100).toFixed(1) }}</span>
            <span v-if="i == 2">{{ (sort.timeRate * 100).toFixed(1) }}</span>
          </div>
          <div v-show="i == 0" style="color: #909399;font-size: 12px;margin-left: 16px;">{{ $t("jian") }}</div>
          <div v-show="i != 0" style="color: #909399;font-size: 18px;margin-left: 16px;">{{ $t("%") }}</div>
        </div>
        <!-- <div style="color: #C0C4CC;font-size: 12px;margin-top: 12px;display: flex;align-items: center;">
					{{$t('chakanwanzhengshuju')}}<i style="color: #C0C4CC;font-size: 12px;" class="yicon yicon-dblarrow_right"></i>
				</div> -->
      </div>
    </div>
    <div ref="chart" style="flex: 1;margin-top: 30px;">
      <div id="quotaChart" style="height: 100%;margin-top: 0px;"></div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: "web_home_mes_alert",
  components: {},

  data() {
    return {
      target: {
        chartEqNames: [],
        chartProducts: [],
        chartUpRates: [],
        chartTimeRates: [],
      },
      timmer: null,
      chart: null,
      options: null,
    };
  },
  created() {
    // this.timmer = setInterval(() => {
    //   this.getEquipmentTarget();
    // }, 60000);
    this.getEquipmentTarget();
  },
  activated() {
    this.resize();
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });
  },
  watch: {
    "$attrs.orgId"(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.getEquipmentTarget();
    },
  },
  destroyed() {
    clearInterval(this.timmer);
  },
  methods: {
    async getEquipmentTarget() {
      let response = await this.http.get("/web/equipment/home/getMesEquipmentTarget", { params: { orgId: this.$attrs.orgId } });
      this.target = response.data;
      this.target.sortDatas = [this.target.productSort, this.target.upRateSort, this.target.timeRateSort];
      this.target.chartEqNames = this.target.equipmentList.map((item) => {
        return item.equipmentName;
      });
      this.target.chartProducts = this.target.equipmentList.map((item) => {
        return item.product;
      });
      this.target.chartUpRates = this.target.equipmentList.map((item) => {
        return (item.upRate * 100).toFixed(1);
      });
      this.target.chartTimeRates = this.target.equipmentList.map((item) => {
        return (item.timeRate * 100).toFixed(1);
      });

      if (!this.chart) {
        setTimeout(() => {
          this.initChart();
        }, 100);
      } else {
        this.options.xAxis.data = this.target.chartEqNames;
        this.options.series[0].data = this.target.chartUpRates;
        this.options.series[1].data = this.target.chartTimeRates;
        this.options.series[2].data = this.target.chartProducts;
        this.chart.setOption(this.options);
      }
    },

    resize() {
      setTimeout(() => {
        this.chart.resize();
      }, 800);
    },
    initChart() {
      this.options = {
        backgroundColor: null,
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          left: "0",
          right: "0",
          bottom: "8",
          top: "30",
          containLabel: true,
        },
        legend: {
          left: "center",
          top: "0%",
          textStyle: {
            color: "#909399",
            fontSize: 12,
          },
          itemWidth: 15,
          itemHeight: 10,
          itemGap: 25,
        },

        dataZoom: [
          {
            show: true,
            height: 8,
            xAxisIndex: [0],
            bottom: 0,
            start: 0,
            end: 80,

            textStyle: {
              color: "transparent",
              fontSize: 12,
            },
            fillerColor: "#f0f2f2",
            borderColor: "transparent",
            backgroundColor: "transparent",
            showDataShadow: false,
            brushSelect: false,
          },
          {
            type: "inside",
            disabled: true,
          },
        ],
        xAxis: {
          show: true,
          type: "category",
          name: "",
          nameLocation: "end",
          nameTextStyle: {
            fontSize: 12,
          },

          inverse: false,
          splitLine: {
            show: false,
            lineStyle: {
              type: "dashed",
              color: "#000",
              width: 1,
            },
          },
          axisTick: {
            show: true,
            alignWithLabel: false,
            interval: "auto",
            inside: true,
            length: 5,
            lineStyle: {
              type: "solid",
              width: 1,
              color: "#909399",
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              width: 1,
              color: "#909399",
            },
          },
          axisLabel: {
            margin: 8,
            interval: "auto",
            rotate: 0,
            fontSize: 12,
            color: "#C0C4CC",
          },
          data: this.target.chartEqNames,
        },
        yAxis: [
          {
            type: "value",
            name: this.$t(""),
            min: 0,
            max: 100,
            interval: 10,
            axisLabel: {
              formatter: "{value} %",
            },
          },
          {},
          {
            show: true,
            type: "value",
            name: this.$t(""),
            min: 0,
            nameTextStyle: {
              color: "#909399",
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#909399",
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              formatter: "{value} ",
              rotate: 0,
              textStyle: {
                color: "#C0C4CC",
              },
            },
            splitLine: {
              show: false,
              lineStyle: {
                type: "dashed",
                color: "#606672",
              },
            },
          },
        ],
        series: [
          {
            name: this.$t("kaijilu"),
            type: "bar",
            barWidth: 10,
            tooltip: {
              valueFormatter: function(value) {
                return value + " %";
              },
            },
            itemStyle: {
              normal: {
                color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#5C41FF",
                  },
                  {
                    offset: 1,
                    color: "#FFFFFF",
                  },
                ]),
                barBorderRadius: 6,
              },
            },
            label: {
              show: false,
              rotate: 0,
              color: "rgba(65, 159, 255, 1)",
              position: "top",
              fontSize: 12,
              labelFormatter: "{data}",
            },
            data: this.target.chartUpRates,
          },
          {
            name: this.$t("jiadonglu"),
            type: "bar",
            barWidth: 10,
            tooltip: {
              valueFormatter: function(value) {
                return value + " %";
              },
            },
            itemStyle: {
              normal: {
                color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#419FFF",
                  },
                  {
                    offset: 1,
                    color: "#FFFFFF",
                  },
                ]),
                barBorderRadius: 6,
              },
            },
            label: {
              show: false,
              rotate: 0,
              color: "rgba(65, 159, 255, 1)",
              position: "top",
              fontSize: 12,
              labelFormatter: "{data}",
            },
            data: this.target.chartTimeRates,
          },
          {
            name: this.$t("chanliang"),
            type: "line",
            yAxisIndex: 2,

            symbol: "none",
            itemStyle: {
              color: "#e6a23c",
              // normal: {
              // 	lineStyle: {
              // 		color: '#e6a23c'
              // 	}
              // }
            },

            data: this.target.chartProducts,
          },
        ],
      };
      var chartDom = document.getElementById("quotaChart");
      this.chart = this.echarts.init(chartDom);
      this.options && this.chart.setOption(this.options);
    },
  },
};
</script>
